import React, { Suspense, lazy, useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route, Routes, useNavigate, Navigate } from 'react-router-dom';
import { authenticateActions } from '../store/store';
import LoginModal from '../pages/login/loginPopupModal';
import PrivateRoute from './privateRouter';
import PublicRoute from './publicRoute';
import Unauthorized from '../pages/unauthorized/unauthorizedPage';
import { AuthenticationDetails } from '../utils/authenticationDetails';
import CreateSubscription from '../pages/subscription/subscriptionCreation ';
import NetworkFailureModal from './networkErrorModal';
import MaintenancePage from '../pages/maintenancePage/maintenancePage';
import NapidAuthAPI from '../api/napidAuthApi';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor } from '../store/store'; // import persistor
import { persistStore } from 'redux-persist';
import { store } from "../store/store.js";
import AuthGate from './authGate.js';
import MobileNumberupdationList from '../pages/billingReport/mobileNumberupdationList.js';

// Lazy load components
const Login = lazy(() => import('../pages/login/login'));
const Dashboard = lazy(() => import('../pages/dashboard/dashboard'));
const Admin = lazy(() => import('../pages/admin/admin'));
const Application = lazy(() => import('../pages/application/application'));
const SuperAdmin = lazy(() => import('../pages/superAdmin/superAdmins'));
const Subscription = lazy(() => import('../pages/subscription/subscription'));
const Autocomplete = lazy(() => import('../pages/jsText/jsTextMessage'));
const SleepTime = lazy(() => import('../pages/sleepTime/sleepTimer'));
const ApplicationsList = lazy(() => import('../pages/applicationsList/listOfApplications'))
const AppAPK = lazy(() => import('../pages/mobileApk/mobileApk'));
const JSLogo = lazy(() => import('../pages/jsLogo/logo'));
const Jsplugin = lazy(() => import('../pages/jsPlugin/jsPlugins'));
const IntegrationSteps = lazy(() => import('../pages/integrationSteps/integratingSteps'));
const Configuration = lazy(() => import('../pages/configuration/configuration'));
const Report4 = lazy(() => import('../pages/reports/report4'));
const Reports = lazy(() => import('../pages/reports/reports'));
const Report2 = lazy(() => import('../pages/reports/report2'));
const Report3 = lazy(() => import('../pages/reports/report3'));
const Report5 = lazy(() => import('../pages/reports/report5'));
const Report6 = lazy(() => import('../pages/reports/report6'));
const Report7 = lazy(() => import('../pages/reports/report7'));
const Report8 = lazy(() => import('../pages/reports/report8'));
const Report9 = lazy(() => import('../pages/reports/report9'));
const Securedid = lazy(() => import('../pages/reports/securedID'));
const MonthlyBillingReport = lazy(() => import("../pages/billingReport/monthlyBillingReport")
);
const RenewalBillingReport = lazy(() => import("../pages/billingReport/renewalBillingReport")
);
const TwoFaReport = lazy(() => import('../pages/reports/2faReport'));
const ForensicReport = lazy(() => import('../pages/reports/ForensicReport'));
const TwoFaPagesConfig = lazy(() => import('../pages/2faPageConfig/2faPageConfig'));
const ViewIssuers = lazy(()=>import('../pages/IssuerManagement/ViewIssuers.js'))

const AppRoutes = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [idleModalOpen, setIdleModalOpen] = useState(false); // Separate state for LoginModal
  const [networkModalOpen, setNetworkModalOpen] = useState(false); // State for NetworkFailureModal
  const [isIdle, setIsIdle] = useState(false);

  const url = new URL(window.location.href);
  const isLoginPage = url.pathname.includes('/login');
  const refreshTokenLocal = localStorage.getItem('refreshToken');
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const accessToken = useSelector((state) => state.auth.accessToken);
  const userRole = useSelector((state) => state.auth.userRole);
  const [modalStatus, setModalStatus] = useState(''); // Status for NetworkFailureModal
  const [modalMessage, setModalMessage] = useState('');
  const [rehydrated, setRehydrated] = useState(false);
  const tokenRefreshIntervalRef = useRef(null);
  const isRefreshingRef = useRef(false);

  // If the app is still rehydrating, don't render anything yet


  const authenticateUser = async () => { //refresh token updating
    try {
      if (refreshTokenLocal) {
        dispatch(authenticateActions.setIsloading(true));

        const regeneratedTokens = await NapidAuthAPI.regenerateAccessToken(refreshTokenLocal);
        const { accessToken, refreshToken } = regeneratedTokens;

        localStorage.setItem("refreshToken", refreshToken);

        const userDetails = await NapidAuthAPI.getUserDetails(accessToken);
        const { roleName } = userDetails;

        dispatch(authenticateActions.setAccessToken({ accessToken }));
        dispatch(authenticateActions.setUserRole({ userRole: roleName }));
        const storedUserId = localStorage.getItem("userEmailId");
        if (storedUserId) {
          dispatch(authenticateActions.setUserEmailId(storedUserId));//karthick
        }
      }
    } catch (error) {
      if (!navigator.onLine) {

        setModalStatus('error');
      } else {

        setModalStatus('error');
      }
      localStorage.removeItem("refreshToken");

      navigate('/login');
    } finally {
      dispatch(authenticateActions.setIsloading(false));
    }
  };
  useEffect(() => {
    //karthick
    const handleStorage = (event) => {
      if (event.key === "refreshToken" && localStorage.getItem("refreshToken") === null) {
        // Dispatch logout and redirect to login page
        dispatch(authenticateActions.logout());
        navigate("/login");
      }
    };

    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  const getAccessToken = async () => { //get accesstoken and get refreshtoken updated
    const refreshTokenUpdated = localStorage.getItem('refreshToken');
    try {
      if (refreshTokenUpdated) {
        const regeneratedTokens = await NapidAuthAPI.regenerateAccessToken(refreshTokenUpdated);

        if (!regeneratedTokens || !regeneratedTokens.accessToken) {
          throw new Error('Failed to regenerate tokens');

        }

        const { accessToken, refreshToken } = regeneratedTokens;

        localStorage.setItem('refreshToken', refreshToken);
        dispatch(authenticateActions.setAccessToken({ accessToken }));

        return accessToken;
      } else {
        localStorage.removeItem('refreshToken');

        navigate('/login');
      }
    } catch (error) {
      if (!navigator.onLine) {

        setModalStatus('error');
        setNetworkModalOpen(true); // Show NetworkFailureModal for connectivity issues
      } else {
        console.log("refreshtokenfailed", error)

        setModalStatus('error');
        setNetworkModalOpen(true);
      }
      console.log("refreshtokenfailed")
      localStorage.removeItem('refreshToken');
    }

    return null;
  };

  useEffect(() => {
    const timeoutDuration = AuthenticationDetails.acessTokenTimeout; //time is set in the authenticationdetails

    // if (!isLoginPage && refreshTokenLocal) {
    //   authenticateUser();
    // }

    const refreshAccessToken = async () => {
      if (!isLoginPage && refreshTokenLocal) {
        authenticateUser();
        setTimeout(refreshAccessToken, timeoutDuration);
      }
    };

    return () => {

    };
  }, []);
  //karthick
  useEffect(() => {
    const persistor = persistStore(store);
    if (persistor.getState().bootstrapped) {
      setRehydrated(true);
    } else {
      const unsubscribe = persistor.subscribe(() => {
        if (persistor.getState().bootstrapped) {
          setRehydrated(true);
          unsubscribe();
        }
      });
    }

    const fallback = setTimeout(() => setRehydrated(true), 1000); // backup
    return () => clearTimeout(fallback);//karthick
  }, []);

  useEffect(() => {
    if (!isAuthenticated || isLoginPage) return;
    let inactivityTimer;
    const resetTimer = () => {
      clearTimeout(inactivityTimer);
      inactivityTimer = setTimeout(() => {
        setIsIdle(true);
        setIdleModalOpen(true); // Show LoginModal when idle
      }, AuthenticationDetails.inActivityTimeout);
    };

    window.addEventListener('mousemove', resetTimer);
    window.addEventListener('keydown', resetTimer);
    resetTimer();

    tokenRefreshIntervalRef.current = setInterval(async () => {
      if (isRefreshingRef.current) {
        return;
      }

      isRefreshingRef.current = true;

      try {
        await getAccessToken()
      } catch (error) {
        // logoutUser();
      } finally {
        isRefreshingRef.current = false;
      }
    }, AuthenticationDetails.acessTokenTimeout);

    return () => {
      clearTimeout(inactivityTimer);
      window.removeEventListener('mousemove', resetTimer);
      window.removeEventListener('keydown', resetTimer);
    };
  }, [isAuthenticated, isLoginPage]);

  const handleIdleModalClose = () => {
    setIdleModalOpen(false);
    setIsIdle(false);
  };
  //karthick
  return (
    <>
      {/* <PersistGate loading={<div>Loading...</div>} persistor={persistor}> */}
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          {/* Public Routes */}
          {/* <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} /> */}
          <Route
            path="/login"
            element={
              isAuthenticated ? <Navigate to="/dashboard" replace /> : <Login />
            }
          />
          <Route
            path="/"
            element={
              isAuthenticated ? <Navigate to="/dashboard" replace /> : <Login />
            }
          />
          <Route path="/maintenancePage" element={<MaintenancePage />} />
          {/* Protected Routes */}
          {isAuthenticated ? (
            <>
              {/* Dashboard: Accessible by NAPID_ADMIN, SUPER_ADMIN, ADMIN */}

              <Route
                path="/dashboard"
                element={
                  <PrivateRoute
                    allowedRoles={["NAPID_ADMIN", "SUPER_ADMIN", "ADMIN"]}>
                    <Dashboard />
                  </PrivateRoute>
                }
              />

              {/* Applications, jstext, jsplugin, integrationsteps, reports: Accessible by SUPER_ADMIN, ADMIN */}
              <Route
                path="/applications"
                element={
                  <PrivateRoute allowedRoles={["SUPER_ADMIN", "ADMIN"]}>
                    <Application />
                  </PrivateRoute>
                }
              />
              <Route
                path="/2fa-pages-config"
                element={
                  <PrivateRoute
                    allowedRoles={["SUPER_ADMIN", "ADMIN"]}>
                    <TwoFaPagesConfig />
                  </PrivateRoute>
                }
              />
              <Route
                path="/jstext"
                element={
                  <PrivateRoute allowedRoles={["SUPER_ADMIN", "ADMIN"]}>
                    <Autocomplete />
                  </PrivateRoute>
                }
              />
              <Route
                path="/jsplugin"
                element={
                  <PrivateRoute allowedRoles={["SUPER_ADMIN", "ADMIN"]}>
                    <Jsplugin />
                  </PrivateRoute>
                }
              />
              <Route
                path="/integrationsteps"
                element={
                  <PrivateRoute allowedRoles={["SUPER_ADMIN", "ADMIN"]}>
                    <IntegrationSteps />
                  </PrivateRoute>
                }
              />
              <Route
                path="/reports"
                element={
                  <PrivateRoute
                    allowedRoles={["SUPER_ADMIN", "ADMIN", "REPORT_ADMIN"]}>
                    <Reports />
                  </PrivateRoute>
                }
              />

              {/* Admin: Accessible by SUPER_ADMIN */}
              <Route
                path="/admin"
                element={
                  <PrivateRoute allowedRoles={["SUPER_ADMIN"]}>
                    <Admin />
                  </PrivateRoute>
                }
              />

              {/* Subscription, Create-Subscription, SuperAdmin, JSLogo, ApplicationsList, SleepTime, AppAPK: Accessible by NAPID_ADMIN */}
              <Route
                path="/subscription"
                element={
                  <PrivateRoute allowedRoles={["NAPID_ADMIN"]}>
                    <Subscription />
                  </PrivateRoute>
                }
              />
              <Route
                path="/create-subscription"
                element={
                  <PrivateRoute allowedRoles={["NAPID_ADMIN"]}>
                    <CreateSubscription />
                  </PrivateRoute>
                }
              />
              <Route
                path="/superadmin"
                element={
                  <PrivateRoute allowedRoles={["NAPID_ADMIN"]}>
                    <SuperAdmin />
                  </PrivateRoute>
                }
              />
              <Route
                path="/jslogo"
                element={
                  <PrivateRoute allowedRoles={["NAPID_ADMIN"]}>
                    <JSLogo />
                  </PrivateRoute>
                }
              />
              <Route
                path="/applicationslist"
                element={
                  <PrivateRoute allowedRoles={["NAPID_ADMIN"]}>
                    <ApplicationsList />
                  </PrivateRoute>
                }
              />
              <Route
                path="/sleeptime"
                element={
                  <PrivateRoute allowedRoles={["NAPID_ADMIN"]}>
                    <SleepTime />
                  </PrivateRoute>
                }
              />
              <Route
                path="/appapk"
                element={
                  <PrivateRoute allowedRoles={["NAPID_ADMIN"]}>
                    <AppAPK />
                  </PrivateRoute>
                }
              />
              <Route
                path="/create-subscription"
                element={
                  <PrivateRoute allowedRoles={["NAPID_ADMIN"]}>
                    <CreateSubscription />
                  </PrivateRoute>
                }
              />
              <Route
                path="/configuration"
                element={
                  <PrivateRoute allowedRoles={["NAPID_ADMIN"]}>
                    <Configuration />
                  </PrivateRoute>
                }
              />
              <Route
                path="/report4"
                element={
                  <PrivateRoute allowedRoles={["NAPID_ADMIN"]}>
                    <Report4 />
                  </PrivateRoute>
                }
              />
              <Route
                path="/report5"
                element={
                  <PrivateRoute allowedRoles={["NAPID_ADMIN"]}>
                    <Report5 />
                  </PrivateRoute>
                }
              />
              <Route
                path="/report6"
                element={
                  <PrivateRoute allowedRoles={["NAPID_ADMIN"]}>
                    <Report6 />
                  </PrivateRoute>
                }
              />
              <Route
                path="/securedID"
                element={
                  <PrivateRoute allowedRoles={["NAPID_ADMIN"]}>
                    <Securedid />
                  </PrivateRoute>
                }
              />
                <Route
                path="/issuer-key-management"
                element={
                  <PrivateRoute allowedRoles={["NAPID_ADMIN"]}>
                    <ViewIssuers />
                  </PrivateRoute>
                }
              />
              <Route
                path="/report7"
                element={
                  <PrivateRoute allowedRoles={["NAPID_ADMIN", "SUPER_ADMIN"]}>
                    <Report7 />
                  </PrivateRoute>
                }
              />
              <Route
                path="/report8"
                element={
                  <PrivateRoute allowedRoles={["NAPID_ADMIN", "SUPER_ADMIN"]}>
                    <Report8 />
                  </PrivateRoute>
                }
              />
              <Route
                path="/report9"
                element={
                  <PrivateRoute allowedRoles={["NAPID_ADMIN", "SUPER_ADMIN"]}>
                    <Report9 />
                  </PrivateRoute>
                }
              />

              <Route
                path="/report2"
                element={
                  <PrivateRoute
                    allowedRoles={["SUPER_ADMIN", "ADMIN", "REPORT_ADMIN"]}>
                    <Report2 />
                  </PrivateRoute>
                }
              />
              <Route
                path="/report3"
                element={
                  <PrivateRoute
                    allowedRoles={["SUPER_ADMIN", "ADMIN", "REPORT_ADMIN"]}>
                    <Report3 />
                  </PrivateRoute>
                }
              />
              <Route
                path="/2fa-report"
                element={
                  <PrivateRoute
                    allowedRoles={["SUPER_ADMIN", "ADMIN", "REPORT_ADMIN"]}>
                    <TwoFaReport />
                  </PrivateRoute>
                }
              />
              <Route
                path="/forensic-report"
                element={
                  <PrivateRoute
                    allowedRoles={["SUPER_ADMIN", "ADMIN", "REPORT_ADMIN"]}>
                    <ForensicReport />
                  </PrivateRoute>
                }
              />
              <Route
                path="/monthlyBillingReport"
                element={
                  <PrivateRoute allowedRoles={["NAPID_ADMIN"]}>
                    <MonthlyBillingReport />
                  </PrivateRoute>
                }
              />
              <Route
                path="/renewalBillingReport"
                element={
                  <PrivateRoute allowedRoles={["NAPID_ADMIN"]}>
                    <RenewalBillingReport />
                  </PrivateRoute>
                }
              />
              <Route
                path="/mobileNumberupdationList"
                element={
                  <PrivateRoute allowedRoles={["NAPID_ADMIN"]}>
                    <MobileNumberupdationList />
                  </PrivateRoute>
                }
              />

              {/* Fallback for unauthorized users */}
              {/* <Route path="*" element={<Unauthorized />} /> */}
            </>
          ) : (
            <Route path="*" element={<Navigate to="/login" replace />} />
          )}
        </Routes>
      </Suspense>
      {/* </PersistGate> */}

      {/* Login Modal for idle state */}
      <LoginModal
        open={idleModalOpen}
        onClose={handleIdleModalClose}
        isSuccess={false}
        message=""
        status="error"
      />

      {/* Network Failure Modal for connectivity issues */}
      <NetworkFailureModal
        open={networkModalOpen}
        onClose={() => setNetworkModalOpen(false)}
        isSuccess={false}
        status={modalStatus}
      />
    </>
  );
};

export default AppRoutes;

